import { observable } from "mobx";

class QuizUserSubjectTracking {
    @observable public daily_active_percent: number = 0;
    @observable public daily_starting_percent: number = 0;
    @observable public daily_questions_left: number = 0;
    @observable public daily_questions_total: number = 0;
    @observable public total_completion_percent: number = 0;
    @observable public questions_total: number = 0;
    public daily_percent_reset_date: Date | undefined = undefined;
    public daily_questions_reset_date: Date | undefined = undefined;
    public questions_total_reset_date: Date | undefined = undefined;

    public constructor(quizUserSubjectTracking?: any) {
        if (!quizUserSubjectTracking) { return; };
        this.daily_active_percent =
            quizUserSubjectTracking.daily_active_percent;
        this.daily_starting_percent =
            quizUserSubjectTracking.daily_starting_percent;
        this.daily_questions_left =
            quizUserSubjectTracking.daily_questions_left;
        this.daily_questions_total =
            quizUserSubjectTracking.daily_questions_total;
        this.questions_total = quizUserSubjectTracking.questions_total;
        this.total_completion_percent =
            quizUserSubjectTracking.total_completion_percent;
        this.daily_percent_reset_date =
            quizUserSubjectTracking.daily_percent_reset_date;
        this.daily_questions_reset_date =
            quizUserSubjectTracking.daily_questions_reset_date;
        this.questions_total_reset_date =
            quizUserSubjectTracking.questions_total_reset_date;
    }

    public percent_complete_today() {
        if (this.daily_active_percent === 0 || this.daily_active_percent - this.daily_starting_percent === 0) {
            return 0;
        }

        return (this.daily_active_percent - this.daily_starting_percent / 100 - this.daily_starting_percent)
    }
}

export { QuizUserSubjectTracking };
